<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-home"></i> 厂商管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
		<div class="handle-box">
			<el-button
			    type="primary"
			    icon="el-icon-circle-plus-outline"
			    class="handle-add"
			    @click="manufactureradd('manufactureraddform')"
			>添加</el-button>
		</div>
        <div class="container">
            <el-table
                :data="manufacturerData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
            >
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="responsibleAreaStr" label="负责区域"></el-table-column>
				<el-table-column prop="liaisonerName" label="负责人"></el-table-column>
                <el-table-column prop="jurisdiction" label="权限" align="center"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="manufacturerEdit(scope.row)"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="manufacturerDelete(scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		<!-- 添加机构分支 -->
		<el-dialog class="branch-dialog" title="添加厂商" :visible.sync="ManufactureraddVisible" width="600px">
		    <el-form ref="manufactureraddform" :model="manufactureraddform" :rules="manufactureraddrules">
				<p class="branch-dialog-title">
					权限信息
				</p>
		        <el-form-item label="分支机构名称" prop="name">
		            <el-input v-model="manufactureraddform.name"></el-input>
		        </el-form-item>
		        <el-form-item label="负责人" prop="liaisonerName">
		            <el-input v-model="manufactureraddform.liaisonerName"></el-input>
		        </el-form-item>
				<!-- 负责区域 -->
				<el-form-item label="负责区域" prop="responsibleArea">
					<el-cascader :options="cityList" :props="optionProps" v-model="manufactureraddform.responsibleArea"></el-cascader>
				 </el-form-item>
				
				 <el-form-item label="选择权限">
				      <el-checkbox v-model="manufactureraddform.isHaveLicense">机械牌照办理</el-checkbox>
				      <el-checkbox v-model="manufactureraddform.isHaveOperationCertificate">机械操作证件办理</el-checkbox>
				  </el-form-item>
				
		    </el-form>
			
		    <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="manufactureraddSave('manufactureraddform')">确 定</el-button>
		        <el-button @click="ManufactureraddVisible = false">取 消</el-button>
		    </span>
		</el-dialog>
		
        <!-- 编辑弹出框 -->
		<el-dialog class="branch-dialog" title="编辑厂商" :visible.sync="ManufacturereditVisible" width="600px">
		    <el-form ref="manufacturereditform" :model="manufacturereditform" :rules="manufactureraddrules">
				<p class="branch-dialog-title">
					权限信息
				</p>
		        <el-form-item label="分支机构名称" prop="name">
		            <el-input v-model="manufacturereditform.name"></el-input>
		        </el-form-item>
		        <el-form-item label="负责人" prop="liaisonerName">
		            <el-input v-model="manufacturereditform.liaisonerName"></el-input>
		        </el-form-item>
				<!-- 负责区域 -->
				<el-form-item label="负责区域" prop="responsibleArea">
					<el-cascader :options="cityList" :props="optionProps" v-model="manufacturereditform.responsibleArea"></el-cascader>
				 </el-form-item>
				
				 <el-form-item label="选择权限">
				      <el-checkbox v-model="manufacturereditform.isHaveLicense">机械牌照办理</el-checkbox>
				      <el-checkbox v-model="manufacturereditform.isHaveOperationCertificate">机械操作证件办理</el-checkbox>
				  </el-form-item>
				
		    </el-form>
			
		    <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="manufacturereditSave('manufacturereditform')">确 定</el-button>
		        <el-button @click="ManufacturereditVisible = false">取 消</el-button>
		    </span>
		</el-dialog>
		
    </div>
</template>




<script>
import {saveManufacturerOrganization,listManufacturerOrganizations,getManufacturerOrganization,updateManufacturerOrganization,deleteManufacturerOrganization,listProvinceCitys } from '@/api/index';// 导入我们的api接口

export default {
    name: 'manufacturerorganizations',
    data() {
        return {
			cityList:[],//省市数据
			optionProps: {
					value: 'id',
					label: 'name'
			},   //省市联动重命名指向
            query: {
                pageIndex: 1,
                pageSize: 10
            },   //分页
			pageTotal: 0,  //数据总条数
            manufacturerData: [],  //列表数据
			manufactureraddform:{
				name:'',
			    liaisonerName:'',
				responsibleArea:[],  //负责区域
				isHaveLicense:false,
			    isHaveOperationCertificate:false,
			},    //添加机构分支表单
			// seemanufacturerlist:{},   //查看数据
			manufactureraddrules: {
			  name: [
				{ required: true, message: '请输入分支机构名称', trigger: 'blur' }
			  ],
			  liaisonerName: [
				{ required: true, message: '请输入负责人', trigger: 'blur' }
			  ],
			  responsibleArea:[
				{type: 'array',required: true, message: '区域不能为空', trigger: 'change'}]
			},  //添加表单验证
			manufacturereditform:{
				isHaveLicense:false,
				isHaveOperationCertificate:false,
			},   //编辑表单
			ManufactureraddVisible:false,  //添加
            ManufacturereditVisible: false, //编辑
			
            
			
        };
    },
    created() {
		var that = this;
		// 列表数据
		this.getlistManufacturerOrganizations();
		listProvinceCitys({
		}).then(res => {
		    // 获取数据成功后的其他操作
			that.cityList = res.data;
		})
		
    },
    methods: {
		// 获取列表数据
		getlistManufacturerOrganizations(){
			listManufacturerOrganizations({
				current: this.query.pageIndex,                    
				size: this.query.pageSize              
			}).then(res => {
				// 获取数据成功后的其他操作
				console.log(res.data)
				this.manufacturerData = res.data.records;  
			    this.pageTotal = res.data.total;
			});
		},
		//点击添加按钮事件
		manufactureradd(formName){
			this.ManufactureraddVisible = true;
			//重置表单数据
			this.$nextTick(()=>{
			  this.$refs.[formName].resetFields();
			})
		},
		// 添加保存
		manufactureraddSave(formName) {
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				  // 是否可以办理牌照:1、不可以 2、可以
				  if(this.manufactureraddform.isHaveLicense){
				  	this.manufactureraddform.isHaveLicense = 2;
				  }else{
				  	this.manufactureraddform.isHaveLicense = 1;
				  }
				  // 是否可以办理操作证书:1、不可以 2、可以
				  if(this.manufactureraddform.isHaveOperationCertificate){
				  	this.manufactureraddform.isHaveOperationCertificate = 2;
				  }else{
				  	this.manufactureraddform.isHaveOperationCertificate = 1;
				  }
				  // 负责区域字段格式处理
				  this.manufactureraddform.responsibleArea = JSON.stringify(this.manufactureraddform.responsibleArea);
				  
				  saveManufacturerOrganization(this.manufactureraddform).then(res => {
					  this.getlistManufacturerOrganizations();
					  if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.ManufactureraddVisible = false;
					  }else if(res.code == 1){
						  this.$message({
						    message: res.message,
						    type: 'warning'
						  });
					  }else{
						  this.$message({
						    message: '报错啦!',
						    type: 'warning'
						  });
					  }
					   
				  });
			  } else {
				return false;
			  }
			});
		  },
		
	
        // 删除操作
        manufacturerDelete(row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
				deleteManufacturerOrganization({},{
					 "organizationId": row.organizationId          
				}).then(res => {
					this.query.pageIndex = 1;
					this.getlistManufacturerOrganizations();
					if(res.code == 0){
					  // 获取数据成功后的其他操作
						this.$message({
						  message: res.message,
						  type: 'success'
						});
					}else if(res.code == 1){
						  this.$message({
							message: res.message,
							type: 'warning'
						  });
					}else{
						  this.$message({
							message: '报错啦!',
							type: 'warning'
						  });
					}
					
				});
			}).catch(() => {});
        },
        // 点击编辑
        manufacturerEdit(row) {
			getManufacturerOrganization({},{
					 "organizationId": row.organizationId          
				}).then(res => {
					console.log(res.data);
					this.manufacturereditform = res.data;
					console.log(this.manufacturereditform.isHaveLicense);
					
					if(typeof(this.manufacturereditform.responsibleArea) == "string"){
						this.manufacturereditform.responsibleArea = JSON.parse(this.manufacturereditform.responsibleArea);	
					}
					//
					if(this.manufacturereditform.isHaveLicense == 2){
						this.manufacturereditform.isHaveLicense = true;
					}else {
						this.manufacturereditform.isHaveLicense = false;
					}
					// 
					if(this.manufacturereditform.isHaveOperationCertificate == 2){
						this.manufacturereditform.isHaveOperationCertificate = true;
					}else {
						this.manufacturereditform.isHaveOperationCertificate = false;
					}
				});
			   this.ManufacturereditVisible = true;
           
        },
        // 保存编辑
        manufacturereditSave(formName) {
            this.$refs[formName].validate((valid) => {
              if (valid) {
				  // 是否可以办理牌照:1、不可以 2、可以
				  if(this.manufacturereditform.isHaveLicense){
				  	this.manufacturereditform.isHaveLicense = 2;
				  }else{
				  	this.manufacturereditform.isHaveLicense = 1;
				  }
				  // 是否可以办理操作证书:1、不可以 2、可以
				  if(this.manufacturereditform.isHaveOperationCertificate){
				  	this.manufacturereditform.isHaveOperationCertificate = 2;
				  }else{
				  	this.manufacturereditform.isHaveOperationCertificate = 1;
				  }
            	  // 负责区域字段格式处理
            	  this.manufacturereditform.responsibleArea = JSON.stringify(this.manufacturereditform.responsibleArea);
            	  
            	  updateManufacturerOrganization(this.manufacturereditform).then(res => {
            		  this.getlistManufacturerOrganizations();
					  
            		  if(res.code == 0){
            			  // 获取数据成功后的其他操作
            				this.$message({
            				  message: res.message,
            				  type: 'success'
            				});
							this.ManufacturereditVisible = false;
            		  }else if(res.code == 1){
            			  this.$message({
            			    message: res.message,
            			    type: 'warning'
            			  });
            		  }else{
            			  this.$message({
            			    message: '报错啦!',
            			    type: 'warning'
            			  });
            		  }
            		   
            	  });
              } else {
            	return false;
              }
            });
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getlistManufacturerOrganizations();
        }
    }
};
</script>

<style scoped>
.handle-box {
	height: 32px;
	line-height: 32px;
    margin-bottom: 20px;
}
.handle-add{
	float: right;
}
.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

/* 弹框样式 */
.branch-dialog-title{
	border-left: 4px solid #409EFF;
	font-size: 16px;
	text-indent: 10px;
	margin-bottom: 20px;
}

.see-list p{
	/* line-height: 32px; */
	margin-bottom: 20px;
	letter-spacing: 1px;
	font-size: 14px;
	text-indent: 15px;
}



</style>
<style>
.branch-dialog	.el-dialog__header{
	background:#409EFF;
	padding: 10px 20px;
}
.branch-dialog	.el-dialog__header	.el-dialog__title{
	color: #fff;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn{
	background:#409EFF;
	top: 12px;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn .el-dialog__close{
	color: #fff;
	font-size: 20px;
}
.branch-dialog .el-dialog__body{
	height:50vh;
	overflow-y: scroll;
	padding: 20px 20px 30px;
}
.branch-dialog .el-form-item__label{
	/* text-align: left; */
	width: 130px;
}
.branch-dialog .el-form-item__content{
	margin-left: 130px;
}

.branch-area{
	position: relative;
	height:32px;
	line-height: 32px;
	margin-bottom: 4px;
}
.branch-area span{
	display: block;
	width:118px;
	text-align: right;
}
.branch-area span::before{
	content: '*';
	color: #F56C6C;
	margin-right: 4px;
}
.branch-area i{
	position: absolute;
	top: 7px;
	right: 0;
	font-size: 20px;
	cursor: pointer;
}
.branch-areaitem{
	position: relative;
}
.branch-areaitem .el-cascader{
	width: 90%;
}
.branch-areaitem b{
	position: absolute;
	top: 7px;
	right: 0;
	font-size: 20px;
	cursor: pointer;
}
.branch-password .el-form-item__label::before{
	content: '*';
	color: #F56C6C;
	margin-right: 4px;
}
</style>
